export default __webpack_public_path__ + "static/media/Green and cream vase_primary.2edde5fb.jpg";